import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permission.service';
import { DialogConfig, FormField } from '../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-rop',
  standalone:false,
  templateUrl: './rop.component.html',
  styleUrl: './rop.component.scss'
})
export class RopComponent implements OnInit , OnDestroy{
  title = 'RoP Table';
  showDialog: boolean = false;
  private subscriptions = new Subscription();
  system: any[] = []
  
  // Reusable dialog properties
  dialogConfig: DialogConfig;
  initialData: any = {};
  viewMode: boolean = false;
  isEditMode: boolean = false;
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'rop_ser', header: 'ROP Ser', filterType: 'text', width: '100px', minWidth: '80px', maxWidth: '120px' },
    { field: 'item_desc', header: 'Description', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },
    { field: 'lpp', header: ' LPP', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'lpp_year', header: 'LPP year', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'moq', header: 'MoQ', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'spareability', header: 'Spareability', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'year', header: 'Year', filterType: 'text', width: '100px', minWidth: '80px', maxWidth: '120px' },
    { field: 'nodal_directorates', header: 'Nodal Directorates', filterType: 'text', width: '180px', minWidth: '140px', maxWidth: '220px' },
    { field: 'remark', header: 'Remarks', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px'  },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false

  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.initializeDialogConfig();
    this.getSystem();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private initializeDialogConfig(): void {
    this.dialogConfig = {
      title: 'Create RoP',
      width: '800px',
      height: 'auto',
      maximizable: true,
      closable: true,
      dismissableMask: true,
      formLayout: 'two-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      fields: [
        {
          key: 'rop_ser',
          label: 'ROP Ser',
          type: 'text',
          placeholder: 'Enter ROP Ser',
          validation: { required: false },
          maxLength: 20
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          validation: { required: true },
          maxLength: 500
        },
        {
          key: 'lpp',
          label: 'LPP',
          type: 'text',
          placeholder: 'Enter LPP',
          validation: { required: true },
          maxLength: 100
        },
        {
          key: 'lpp_year',
          label: 'LPP Year',
          type: 'text',
          placeholder: 'Enter LPP Year',
          validation: { required: true },
          maxLength: 100
        },
        {
          key: 'moq',
          label: 'MoQ',
          type: 'text',
          placeholder: 'Enter MoQ',
          validation: { required: true },
          maxLength: 100
        },
        {
          key: 'spareability',
          label: 'Spareability',
          type: 'text',
          placeholder: 'Enter Spareability',
          validation: { required: true },
          maxLength: 100
        },
        {
          key: 'year',
          label: 'Year',
          type: 'text',
          placeholder: 'Enter Year',
          validation: { required: false },
          maxLength: 4
        },
        {
          key: 'nodal_directorates',
          label: 'Nodal Directorates',
          type: 'text',
          placeholder: 'Enter Nodal Directorates',
          validation: { required: false },
          maxLength: 100
        },
        {
          key: 'remark',
          label: 'Remark',
          placeholder: 'Enter Remark',
          type: 'text',
          validation: { required: true },
          maxLength: 100
        }
      ]
    };
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/rop/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      const resp = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.results)
          ? res.results
          : Array.isArray(res?.data?.results)
            ? res.data.results
            : [];

      this.totalRecords = res?.count || res?.data?.count || resp.length || 0;
      this.system = resp.map((item: any) => this.mapRoPRow(item));
    });
    this.subscriptions.add(sub);
  }

  private mapRoPRow(item: any): any {
    return {
      ...item,
      rop_ser: item?.rop_ser ?? '',
      description: item?.item_desc ?? item?.description ?? '',
      item_desc: item?.item_desc ?? item?.description ?? '',
      lpp: item?.lpp ?? '',
      lpp_year: item?.lpp_year ?? '',
      moq: item?.moq ?? '',
      spareability: item?.spareability ?? '',
      year: item?.year ?? '',
      nodal_directorates: item?.nodal_directorates ?? '',
      remark: item?.remark ?? '',
    };
  }


  addSystem() {
    this.dialogConfig.title = 'Create RoP';
    this.dialogConfig.submitButtonText = 'Submit';
    this.initialData = {};
    this.viewMode = false;
    this.isEditMode = false;
    this.showDialog = true;
  }
  // Dialog event handlers
  onDialogSubmit(formData: any): void {
    if (this.viewMode) {
      this.closeDialog();
      return;
    }

    if (this.isEditMode) {
      this.updateRoP(formData);
    } else {
      this.createRoP(formData);
    }
  }

  onDialogCancel(): void {
    this.closeDialog();
  }

  onDialogClose(): void {
    this.closeDialog();
  }

  private closeDialog(): void {
    this.showDialog = false;
    this.initialData = {};
    this.viewMode = false;
    this.isEditMode = false;
    this.dialogConfig.showCancelButton = true;
  }

  private createRoP(formData: any): void {
    const payload = {
      rop_ser: formData.rop_ser,
      item_desc: formData.description,
      lpp: formData.lpp,
      lpp_year: formData.lpp_year,
      moq: formData.moq,
      spareability: formData.spareability,
      year: formData.year,
      nodal_directorates: formData.nodal_directorates,
      remark: formData.remark,
    };

    const sub = this.api.postAPI('/master/rop/', payload).subscribe((res: any) => {
      if (res) {
        const created = res?.data || res;
        if (created && (created.id || created.item_desc || created.description)) {
          this.system = [this.mapRoPRow(created), ...this.system];
          this.totalRecords = (this.totalRecords || 0) + 1;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'RoP created successfully'
        });
        this.closeDialog();
        this.getSystem({ page: 1 });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res.name || 'Failed to create RoP'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  private updateRoP(formData: any): void {
    const sectionId = this.selectedsystem.id;
    const payload = {
      rop_ser: formData.rop_ser,
      item_desc: formData.description,
      lpp: formData.lpp,
      lpp_year: formData.lpp_year,
      moq: formData.moq,
      spareability: formData.spareability,
      year: formData.year,
      nodal_directorates: formData.nodal_directorates,
      remark: formData.remark,
    };

    const sub = this.api.putAPI(`/master/rop/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'RoP updated successfully'
        });
        this.closeDialog();
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res.detail || 'Failed to update RoP'
        });
      }
    });
    this.subscriptions.add(sub);
  }
viewSystem(rowData: any) {
  this.viewMode = true;
  this.isEditMode = false;
  this.dialogConfig.title = 'View RoP';
  this.dialogConfig.submitButtonText = 'Close';
  this.dialogConfig.showCancelButton = false;
  
  if (rowData && rowData.id) {
    this.selectedsystem = rowData;
    this.initialData = {
      rop_ser: rowData.rop_ser,
      description: rowData.description || rowData.item_desc || '',
      lpp: rowData.lpp,
      lpp_year: rowData.lpp_year,
      moq: rowData.moq,
      spareability: rowData.spareability,
      year: rowData.year,
      nodal_directorates: rowData.nodal_directorates,
      remark: rowData.remark,
    };
    this.showDialog = true;
  }
}

updateSystem(equipment: any): void {
  this.viewMode = false;
  this.isEditMode = true;
  this.dialogConfig.title = 'Update RoP';
  this.dialogConfig.submitButtonText = 'Update';
  this.dialogConfig.showCancelButton = true;
  
  this.selectedsystem = equipment;
  this.initialData = {
    rop_ser: equipment.rop_ser,
    description: equipment.description || equipment.item_desc || '',
    lpp: equipment.lpp,
    lpp_year: equipment.lpp_year,
    moq: equipment.moq,
    spareability: equipment.spareability,
    year: equipment.year,
    nodal_directorates: equipment.nodal_directorates,
    remark: equipment.remark,
  };
  this.showDialog = true;
}



  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    // this.selectedsystem = equipment;
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/rop/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'RoP Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/rop', 'Edit') ||
      this.permissionService.hasPrivilege('/master/rop', 'Delete')||
      this.permissionService.hasPrivilege('/master/rop', 'View');
  }
}
